import {
  generateGenericDocs,
  GenericMachine,
} from '_core/domain/Utils/Generic/Machines/GenericMachine';
import { IDocs } from '_core/types';
import { ErrorsFlowTypes } from '_core/types/Responses';
import { Bundle } from '_core/util';
import { validateDocumentApi as API } from '../Apis';

export const ValidateDocumentDocs: IDocs = generateGenericDocs(
  {
    title: 'ValidateDocument',
    description: '',
    version: '0.0.1',
    codeToExecute: 'Services.AccountServices.validateDocument',
  },
  API.definitions,
);

const prepareCall = (stateRequestParameters: any) => {
  const config = Bundle.getValue('config');

  return API.call.post({
    type: stateRequestParameters.params.type,
    value: stateRequestParameters.params.value,
    recaptcha:
      config.service.environment === 'MOCK'
        ? undefined
        : { responseToken: stateRequestParameters.params?.tokenRecaptcha },
  });
};

const handleSucessFinalResponseFunction = (data: any) => {
  const responseData = {
    ...data,
    isPreRegistration: false,
    preRegistrationDetails: {
      isPreRegistrationGOL: false,
      isPreRegistrationShellBox: false,
      isPreRegistrationCobranding: false,
      isPreRegistrationBank: false,
    },
  };
  if (data && data.partner && data.status) {
    if (data.status === 'INCOMPL. REGISTRATION PARTNER') {
      if (data.partner === 'G3') {
        responseData.preRegistrationDetails.isPreRegistrationGOL = true;
      } else if (data.partner === 'SHE') {
        responseData.preRegistrationDetails.isPreRegistrationShellBox = true;
      } else {
        responseData.preRegistrationDetails.isPreRegistrationBank = true;
      }
    } else if (data.status === 'PRE REGISTRATION BANKS') {
      responseData.preRegistrationDetails.isPreRegistrationBank = true;
    } else if (data.status === 'ACTIVE') {
      responseData.preRegistrationDetails.isPreRegistrationCobranding = [
        'CSA',
        'CBB',
        'CBR',
      ].includes(data.partner);
    }

    responseData.isPreRegistration =
      responseData.preRegistrationDetails.isPreRegistrationGOL ||
      responseData.preRegistrationDetails.isPreRegistrationShellBox ||
      responseData.preRegistrationDetails.isPreRegistrationCobranding ||
      responseData.preRegistrationDetails.isPreRegistrationBank;
  }
  if (data?.smilesToken) Bundle.setValue('smilesToken', data?.smilesToken);

  return responseData;
};

const handleErrorFlowFinalResponseFunction = (infos: ErrorsFlowTypes) => {
  const smilesAccountFound = infos?.alreadyRegistrationDocument;
  const smilesErrorService = infos?.errorService || !smilesAccountFound;

  return { smilesAccountFound, smilesErrorService };
};

export const ValidateDocumentMachine = GenericMachine(
  prepareCall,
  {
    docs: ValidateDocumentDocs,
    definitions: API.definitions,
  },
  {
    handleSucessFinalResponseFunction,
    handleErrorFlowFinalResponseFunction,
  },
);
